'use strict';

var flatpickrModule = require('flatpickr');
var flatpickr = flatpickrModule.default || flatpickrModule;
var toastMessageHelper = require('../../utils/toastMessageHelper');
var dateandslotsUtils = require('../../utils/dataAndSlots');
var errorMessage = $('#errormessage').val();

var $body = $('body');
var $profileForm = $('#astral-formdata-details');
var MAX_FILE_BYTES = $profileForm.data('max-file-size') || 5242880; // Default 5MB
var UPLOAD_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

/**
 * Creates the custom time picker for the time-of-birth field when the field is present.
 *
 * @returns {Object|null} The flatpickr instance when available; otherwise null.
 */
function initTimeOfBirthPicker() {
    var timeInput = document.getElementById('timeofbirth');
    var $timeInput;
    var existingPicker;

    if (!timeInput) {
        return null;
    }

    $timeInput = $(timeInput);
    existingPicker = $timeInput.data('timeOfBirthFlatpickr');

    if (existingPicker) {
        return existingPicker;
    }

    existingPicker = flatpickr(timeInput, {
        enableTime: true,
        noCalendar: true,
        static: true,
        dateFormat: 'H:i',
        altInput: true,
        altFormat: 'h:i K',
        time_24hr: false,
        minuteIncrement: 1,
        disableMobile: true,
        onReady: function (selectedDates, dateStr, instance) {
            if (instance.altInput) {
                instance.altInput.setAttribute('autocomplete', 'off');
            }
        },
        onClose: function (selectedDates, dateStr, instance) {
            $(instance.input).trigger('blur');
        }
    });

    $timeInput.data('timeOfBirthFlatpickr', existingPicker);

    return existingPicker;
}

/**
 * Focuses the visible control for a form field, including flatpickr alt inputs.
 *
 * @param {JQuery} $field - jQuery-wrapped form field.
 * @returns {void}
 */
function focusField($field) {
    var picker = $field && $field.data('timeOfBirthFlatpickr');

    if (picker && picker.altInput) {
        picker.open();
        picker.altInput.focus();
        return;
    }

    $field.focus();
}

/**
 * Validates a file's type and size against allowed constraints.
 *
 * @param {File} file - The selected file object.
 * @param {string[]} allowedTypes - List of allowed MIME types.
 * @param {jQuery} $input - jQuery-wrapped file input element.
 * @param {jQuery} $errorEl - jQuery-wrapped error message element.
 * @param {string} invalidTypeMsg - Error message for invalid type.
 * @returns {boolean} True if file is valid; otherwise false.
 */
function validateFileTypeAndSize(file, allowedTypes, $input, $errorEl, invalidTypeMsg) {
    // type check
    if (allowedTypes.indexOf(file.type) === -1) {
        $input.addClass('is-invalid');
        $errorEl.text(invalidTypeMsg);
        return false;
    }

    // size check
    if (file.size > MAX_FILE_BYTES) {
        $input.addClass('is-invalid');
        $errorEl.text($profileForm.data('file-size-exceeds'));
        return false;
    }

    $input.removeClass('is-invalid');
    $errorEl.text('');
    return true;
}

/**
 * Converts bytes to MB with 2 decimal places
 * @param {number} bytes - File size in bytes
 * @returns {string} Size in MB
 */
function bytesToMB(bytes) {
    return (bytes / (1024 * 1024)).toFixed(2);
}

var uploadedFiles = [];

/**
 * Renders the list of uploaded files in the UI and updates hidden input fields
 * with file URLs and names.
 *
 * - Displays image thumbnails for image files.
 * - Displays a PDF icon for non-image files.
 * - Updates hidden inputs with comma-separated file URLs and names.
 * - Hides the file display container if no files are uploaded.
 *
 * @function renderUploadedFiles
 * @returns {void}
 */
function renderUploadedFiles() {
    var $filesDisplay = $('#selectedFilesDisplay');
    var $filesList = $('.selected-files-list');
    var $uploadUrl = $('#uploadFileUrl');
    var $uploadName = $('#uploadFileName');

    $filesList.empty();

    if (uploadedFiles.length === 0) {
        $filesDisplay.addClass('d-none').hide();
        $uploadUrl.val('');
        $uploadName.val('');
        return;
    }

    var urls = [];
    var names = [];
    for (var i = 0; i < uploadedFiles.length; i++) {
        var f = uploadedFiles[i];
        urls.push(f.url || f.base64);
        names.push(f.name);

        var fileItemInfo = $('#fileItemTemplate .file-item-row').clone();
        fileItemInfo.attr('data-index', i);

        if (f.type && f.type.startsWith('image/')) {
            fileItemInfo.find('.astro-file-thumb').attr('src', f.preview).removeClass('d-none');
            fileItemInfo.find('.pdf-thumb').addClass('d-none');
        } else {
            fileItemInfo.find('.astro-file-thumb').addClass('d-none');
            fileItemInfo.find('.pdf-thumb').removeClass('d-none');
        }

        fileItemInfo.find('.astro-file-name').text(f.name);
        if (f.size) {
            fileItemInfo.find('.astro-file-size').text(f.size + ' MB');
        } else {
            fileItemInfo.find('.astro-file-size').text('');
        }

        fileItemInfo.find('.astro-file-remove-btn').attr('data-index', i);

        $filesList.append(fileItemInfo);
    }

    $uploadUrl.val(urls.join(','));
    $uploadName.val(names.join(','));
    $filesDisplay.removeClass('d-none').show();
}

/**
 * Clears any previously uploaded files from memory and UI.
 *
 * This is needed because `uploadedFiles` is module-scoped and survives
 * AJAX page transitions into the form details step.
 *
 * @returns {void}
 */
function resetUploadedFiles() {
    uploadedFiles = [];

    // Clear any hidden fields / inputs if present
    $('#uploadFileBase64, #uploadFileUrl, #uploadFileName, #uploadFile').val('');

    // Clear error state if present
    var $errorMsg = $('.pan-file-error');
    if ($errorMsg.length) {
        $errorMsg.text('').addClass('d-none');
    }

    renderUploadedFiles();
}

module.exports = function () {
    initTimeOfBirthPicker();

    $body.on('click', '.upload-file-trigger', function () {
        $('#uploadFile').trigger('click');
    });
    $body.on('change', '#uploadFile', function (e) {
        var fileInput = e.target;
        var $errorMsg = $('.pan-file-error');

        if (!fileInput.files || !fileInput.files.length) {
            return;
        }

        var filesToProcess = Array.from(fileInput.files);
        var uploadPromises = [];

        $.spinner().start();

        filesToProcess.forEach(function (file) {
            if (!validateFileTypeAndSize(
                file,
                UPLOAD_ALLOWED_TYPES,
                $('.upload-file-trigger'),
                $errorMsg,
                $errorMsg.data('invalid-error') || 'Please upload a valid PNG, JPEG, or PDF file'
            )) {
                return;
            }

            var formData = new FormData();
            formData.append('uploadFile', file);

            var promise = $.ajax({
                url: $('#astral-formdata-details').data('save-file-url'),
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false
            }).then(function (response) {
                if (response.success) {
                    var fileData = {
                        name: response.fileName,
                        size: bytesToMB(file.size),
                        type: file.type,
                        url: response.imageUrl,
                        base64: ''
                    };

                    if (file.type.startsWith('image/')) {
                        var deferred = $.Deferred();
                        var fileReader = new FileReader();
                        fileReader.onload = function (er) {
                            fileData.preview = er.target.result;
                            uploadedFiles.push(fileData);
                            deferred.resolve();
                        };
                        fileReader.readAsDataURL(file);
                        return deferred.promise();
                    }
                    uploadedFiles.push(fileData);
                    return $.Deferred().resolve().promise();
                }
                $errorMsg.text(response.message || 'Failed to upload file').removeClass('d-none');
                return $.Deferred().reject().promise();
            });

            uploadPromises.push(promise);
        });

        $.when.apply($, uploadPromises).always(function () {
            $.spinner().stop();
            renderUploadedFiles();
            fileInput.value = ''; // Reset input so same files can be selected again
            if (uploadedFiles.length > 0) {
                $errorMsg.text('').addClass('d-none');
                toastMessageHelper.showNotification('File uploaded successfully', '');
            }
        }).fail(function () {
            $errorMsg.text('Some files failed to upload. Please try again.').removeClass('d-none');
        });
    });

    // Handle file remove
    $body.on('click', '.astro-file-remove-btn', function () {
        var index = $(this).data('index');
        uploadedFiles.splice(index, 1);
        renderUploadedFiles();

        if (uploadedFiles.length === 0) {
            $('#uploadFileBase64, #uploadFileUrl, #uploadFile').val('');
        }
    });
};

$('body').on('click', '#astralpagecontainer .pickup-type-switch label', function () {
    $('#astralpagecontainer .pickup-type-switch label').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('change', 'input[name="astrologer"]', function () {
    $('.astralService').addClass('d-none');
});

$('body').on('click', '#astralstorepage-container .storedata .store-container', function () {
    $('#astralstorepage-container .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '#astral-detailspage-container .astrologer-details .astro-card', function () {
    $('#astral-detailspage-container .astrologer-details .astro-card').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '#astral-selectedpage-container .astrologer-details .astro-card', function () {
    $('#astral-selectedpage-container .astrologer-details .astro-card').removeClass('checked');
    $(this).addClass('checked');
});

$('body').on('click', '#astral-selectedpage-container .storedata .store-container', function () {
    $('#astral-selectedpage-container .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
});

// Use event delegation for click events on dynamically loaded elements
$('body').on('click', '.date-picker-icon, #dateofbirth', function () {
    var $dateInput = $('#dateofbirth');
    if (!$dateInput.data('datepicker')) {
        $dateInput.datepicker({
            format: 'dd/mm/yyyy',
            language: 'en',
            autoclose: true,
            todayHighlight: true,
            endDate: '+0d',
            container: '.dob-input-wrapper',
            weekStart: 1,
            maxViewMode: 2
        });

        $dateInput.on('show', function () {
            $('.table-condensed .prev').text('');
            $('.table-condensed .next').text('');
        });
    }

    $dateInput.datepicker('show');
});

// Initialize datepicker on page load
$(document).ready(function () {
    dateandslotsUtils.initializeEarPiercingDatepicker();
    // Load time slots if store is already selected (coming back from form page)
    var selectedStore = $('#astral-formdata-details .storedata .store-container.checked input[type="radio"]').val();
    if (selectedStore) {
        dateandslotsUtils.loadSlots(selectedStore);
    }
});

/**
 * Resets the time slot selection to its default state.
 * Updates the text of the selected time slot element to show the alternative text
 * (either from data-alttext attribute or defaults to 'Choose...').
 *
 * @function resetTimeSlot
 * @returns {void}
 */
function resetTimeSlot() {
    var $sel = $('.astral-selected-value');
    var altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
    $sel.text(altText);
}

$('body').on('change', '#astral-selectedpage-container input[name="storeOption"]', function () {
    var storeId = $(this).val();
    dateandslotsUtils.loadSlots(storeId);
    resetTimeSlot();

    var $dateInput = $('#ckc-astral-appointment-date');
    if ($dateInput.length && $dateInput.data('datepicker')) {
        $dateInput.datepicker('setDate', null);
        $dateInput.val('');
        dateandslotsUtils.initializeEarPiercingDatepicker();
    }

    var $tasSelectedValue = $('.astral-selected-value, .astral-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '').removeClass('timeslot-selected-value');
    }
});

$('body').on('click', '#astraltimeslot', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }

    var selectedDate = $('#ckc-astral-appointment-date').val().trim();
    var astrolgerId = $('#astrostaffid').val() ? $('#astrostaffid').val().trim() : '';
    if (!selectedDate) {
        return;
    }

    var storeID = $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val()
    || $('#astralstorepage-container .storedata .store-container.checked input[type="radio"]').val();
    var selectedslot = $('.astral-selected-value').attr('data-slot') || ($('.selected-value.astral-selected-value').text().trim() !== 'select your slot' ? $('.selected-value.astral-selected-value').text().trim() : '');
    var url = $(this).data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        storeID: storeID,
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    if (astrolgerId) {
        tryatshowroomData.astrologerId = astrolgerId;
        tryatshowroomData.astroType = 'astrologer';
        tryatshowroomData.category = 'availableslot';
    }

    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#astraltimeslotplaced').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.pickup-slots, .pickup-slot-scroll.scroll-bar').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('.pickup-slot-scroll.scroll-bar').removeClass('d-none');
            $('#astraltimeslotplaced').html(data);
            $('.pickup-slot-scroll').scrollTop(0);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#astraltimeslot .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;
    var selectedSlot = $(this).data('id');
    $('#astraltimeslotplaced').val(selectedSlot);
    $('.astral-selected-value').attr('data-slot', selectedSlot);
});

$('body').on('click', '#ckc-astral-appointment-date, .astral-icon', function (e) {
    e.preventDefault();
    var selectedStore = $('#astralstorepage-container .storedata .store-container.checked input[type="radio"]').val();
    var $dateInput = $('#ckc-astral-appointment-date');
    if (!selectedStore) {
        if (!$dateInput.data('datepicker')) {
            dateandslotsUtils.initializeEarPiercingDatepicker();
        }
        $dateInput.datepicker('show');
    } else {
        var storeHolidays = $('#ckcstoreholidays[data-storeid="' + selectedStore + '"]').val();
        if ($dateInput.data('datepicker')) {
            $dateInput.datepicker('destroy');
        }
        dateandslotsUtils.initializeEarPiercingDatepicker(storeHolidays);
        $dateInput.datepicker('show');
    }
});

$('body').on('click', '.astral-proceed-btn', function (e) {
    e.preventDefault();

    var $selected = $('input[name="astrologer"]:checked');
    var astralService = $selected.val() || '';
    var formurl = $selected.data('url');

    var isValid = true;

    if (astralService === '') {
        $('.astralService').removeClass('d-none');
        isValid = false;
    }

    if (!isValid) return;
    $.spinner().start();
    if (isValid) {
        $.ajax({
            url: formurl,
            method: 'GET',
            data: {
                astralService: astralService
            },
            success: function (html) {
                $('#astralpagecontainer').addClass('d-none');
                var $appointmentFormContainer = $('#astral-selectedpage-container');
                if ($appointmentFormContainer.length) {
                    $appointmentFormContainer.empty();
                    $appointmentFormContainer.html(html);
                }
                $.spinner().stop();
                $('html, body').animate({
                    scrollTop: $('.appointment-service').offset().top
                }, 500);
                $('.appointment-service').scrollTop(0);
                $appointmentFormContainer.removeClass('d-none');
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification(errorMessage);
            }
        });
    }
});

$('body').on('click', '#astrologer-btn', function () {
    var selectedastraloption = $('#astral-selectedpage-container .astrologer-details .astro-card.checked');
    var slectedStaffid = selectedastraloption.data('id') || '';
    var selectedStaffName = selectedastraloption.data('name') || '';
    var slectedShowroomID = selectedastraloption.data('show-id') || '';
    var astralstorepage = '';
    var selectedoption = $('#selectedoption').val();

    if (slectedStaffid) {
        astralstorepage = $(this).data('url');
        $.spinner().start();
        $.ajax({
            url: astralstorepage,
            type: 'GET',
            data: {
                selectedoption: selectedoption,
                staffid: slectedStaffid,
                showroomID: slectedShowroomID,
                selectedStaffName: selectedStaffName
            },
            success: function (data) {
                $('#astral-selectedpage-container').addClass('d-none');
                $('#astralstorepage-container').removeClass('d-none');
                $('#astralstorepage-container').html(data);
                $.spinner().stop();
                $('html, body').animate({
                    scrollTop: $('#astralstorepage-container').offset().top
                }, 500);
                $('#astralstorepage-container').scrollTop(0);
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification(errorMessage);
            }
        });
    }
});

$('body').on('click', '#astral-formdata-details .country-code .custom-option-value', function () {
    var $this = $(this);
    var countryCode = $this.data('id');
    var phoneLength = $this.data('phonelength');
    var $phoneInput = $('#astral-formdata-details .phone-input');
    $phoneInput.attr('data-countrycode', countryCode);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(countryCode);
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    if (phoneLength) {
        $phoneInput.attr('maxlength', phoneLength);
    }
    $phoneInput.val('');
    $phoneInput.removeClass('is-invalid');
    $phoneInput.siblings('.invalid-feedback').text('').hide();
});

/**
 * Validates a guest checkout field using contextual rules (name, email, phone, or generic required checks).
 * @param {JQuery} $field - The input/select element wrapped in jQuery whose value should be validated.
 * @returns {boolean} True when the field value complies with its rules; otherwise false with feedback applied.
 */
function validateField($field) {
    var value = $field.val();
    var isValid = true;
    var errorMsg = '';
    var $errorDiv;
    var fieldId = $field.attr('id');
    var isNameField = fieldId === 'firstName' || fieldId === 'lastName';
    var isEmailField = $field.attr('type') === 'email';
    var isPhoneField = $field.attr('type') === 'tel' || fieldId === 'phone';
    var isPostalCodeField = fieldId === 'pincode' || fieldId === 'updatedpostalCode';
    var isCityField = fieldId === 'city' || fieldId === 'updatedcity';
    var isAddressField = fieldId === 'Address1' || fieldId === 'Address2' || fieldId === 'updateaddress1' || fieldId === 'updateaddress2';
    var isUploadField = fieldId === 'toupload';
    var isDateOfBirthField = fieldId === 'dateofbirth';
    var isTimeOfBirthField = fieldId === 'timeofbirth';
    var isPlaceOfBirthField = fieldId === 'placeofbirth';

    if ($field.attr('type') === 'checkbox') {
        if ($field.attr('id') === 'termsAccepted') {
            $errorDiv = $field.closest('.form-check').find('.invalid-feedback');

            if (!$field.is(':checked')) {
                $field.addClass('is-invalid');
                $errorDiv.text($field.data('missing-error')).show();
                return false;
            }
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
            return true;
        }
        return true;
    }

    if (isNameField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var pattern = /^[A-Za-z][A-Za-z\s]*$/;
        if (isValid && value && !pattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('invalid-error');
        }
    } else if (isEmailField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9@._-]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var emailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (isValid && value && !emailPattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('pattern-mismatch') || 'Please enter a valid email address';
        }
    } else if (isPhoneField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var requiredLength = parseInt($field.attr('data-phonelength'), 10)
            || parseInt($field.attr('maxlength'), 10)
            || 10;

        var countryCode = $field.attr('data-countrycode');

        if (countryCode === '+91' && value.length > 0) {
            if (!/^[6-9]/.test(value)) {
                $field.val('');
                value = '';
                isValid = false;
                errorMsg = $field.data('format-error');
            }
        }

        if (isValid && value.length !== requiredLength) {
            isValid = false;
            errorMsg = 'Please enter valid phone number';
        }
    } else if (isPostalCodeField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue.length > 6) cleanedValue = cleanedValue.substring(0, 6);
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        } else if (value && value.length !== 6) {
            isValid = false;
            errorMsg = 'Postal code must be 6 digits';
        }
    } else if (isCityField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'City is required';
        }
    } else if (isAddressField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9\s,.\-/]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Address is required';
        }
    } else if (isUploadField) {
        var uploadFileBase64 = $('#uploadFileBase64').val();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !uploadFileBase64) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Please upload a file';
        }
        $errorDiv = $field.closest('.upload-file-upload').find('.upload-file-error');
        if (!isValid) {
            $field.addClass('is-invalid');
            $errorDiv.text(errorMsg).show();
        } else {
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
        }
        return isValid;
    } else if (isDateOfBirthField) {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Date of birth is required';
        }
        // Find error div outside the wrapper
        $errorDiv = $field.closest('.dob-input-wrapper').siblings('.invalid-feedback');
        if (!isValid) {
            $field.addClass('is-invalid');
            $errorDiv.text(errorMsg).show();
        } else {
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
        }
        return isValid;
    } else if (isTimeOfBirthField) {
        value = value.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Time of birth is required';
        }
        // Find error div outside the wrapper
        $errorDiv = $field.closest('.timeofbirth-input-wrapper').siblings('.invalid-feedback');
        if (!isValid) {
            $field.addClass('is-invalid');
            $errorDiv.text(errorMsg).show();
        } else {
            $field.removeClass('is-invalid');
            $errorDiv.text('').hide();
        }
        return isValid;
    } else if (isPlaceOfBirthField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'Place of birth is required';
        }
    } else {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    }

    $errorDiv = $field.siblings('.invalid-feedback');

    if (!isValid) {
        $field.addClass('is-invalid');
        $errorDiv.text(errorMsg);
    } else {
        $field.removeClass('is-invalid');
        $errorDiv.text('').hide();
    }

    return isValid;
}

$('body').on('change input blur', '#astral-formdata-details input', function () {
    validateField($(this));
});

$('body').on('input', '#email, #timeofbirth, #placeofbirth, #optionattribute', function () {
    var $field = $(this);
    var value = $field.val();
    var cleanedValue = value.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
    if (value !== cleanedValue) {
        $field.val(cleanedValue);
    }
});

$('body').on('blur', '#email, #timeofbirth, #placeofbirth, #optionattribute', function () {
    var $field = $(this);
    $field.val($field.val().trim());
    validateField($field);
});

$('body').on('click', '.online-go-back', function (e) {
    e.preventDefault();
    var $container = $('#astralpagecontainer');
    // var $proceedBtn = $container.find('.astral-proceed-btn');
    var previouspageUrl = $('#previouspageUrl').val();
    var previouspage = '';
    var selectedValue = $container.find('input[type="radio"]:checked').val();
    $.spinner().start();
    if (previouspageUrl) {
        previouspage = previouspageUrl;
        $.ajax({
            url: previouspage,
            type: 'GET',
            success: function (data) {
                $('#astral-selectedpage-container').addClass('d-none');
                var $newContainer = $('#astralpagecontainer').parent();
                $newContainer.empty();
                $newContainer.html(data);
                $.spinner().stop();
                if (selectedValue) {
                    $newContainer.find('input[type="radio"]').prop('checked', false);
                    $newContainer.find('label').removeClass('checked');
                    var $newInput = $newContainer.find('input[value="' + selectedValue + '"]');
                    $newInput.prop('checked', true);
                    $newInput.closest('label').addClass('checked');
                }
                $newContainer.removeClass('d-none');
            },
            error: function () {
                $.spinner().stop();
                toastMessageHelper.showNotification(errorMessage);
            }
        });
    }
});

$('body').on('click', '.goto-detailspage', function (e) {
    e.preventDefault();
    var astrologerDetailsUrl = $('#astrologerdetails-page').val();
    var selectedoption = $('#selectedoption').val();
    var selectedAstrologer = $('#astralstorepage-container').data('selected-staff-id')
        || $('#astrostaffid').val()
        || $('#astral-selectedpage-container .astrologer-details .astro-card.checked').data('id')
        || '';
    $.spinner().start();
    $.ajax({
        url: astrologerDetailsUrl,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            selectedAstrologer: selectedAstrologer
        },
        success: function (data) {
            $('#astral-selectedpage-container').html(data);
            $('#astral-selectedpage-container').removeClass('d-none');
            $('#astralstorepage-container').addClass('d-none');
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#astral-selectedpage-container').offset().top
            }, 500);
            $('#astral-selectedpage-container').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '#onlinedetails-btn, #offlinedetails-btn', function (e) {
    e.preventDefault();
    var astrologerDetailsUrl = $('#astrologerdetails-page').val();
    var selectedoption = $('#selectedoption').val();
    var offSelectedStore = $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val();
    var offSelectedSlot = $('#astral-selectedpage-container .astral-selected-value').text().trim();
    var offlineselectedDate = $('#ckc-astral-appointment-date').val().trim();
    var onlineselecteddate = $('#ckc-astral-appointment-date').val().trim();
    var onlineselectedslot = $('#astral-selectedpage-container .astral-selected-value').text().trim();
    var isValid = true;
    if (offlineselectedDate === '') {
        $('.select-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (offSelectedSlot === 'select your slot') {
        $('.pickup-slots').removeClass('d-none');
        $('.noslots-available').addClass('d-none');
        isValid = false;
    }

    var $datePickerWrapper = $('.date-picker-input');
    var $slotdiv = $('#slot-dropdown-section');
    var $dateError = $('.select-date-picker');
    var $slotError = $('.pickup-slots');
    if (!$slotError.hasClass('d-none')) {
        $slotdiv.addClass('is-invalid');
    } else {
        $slotdiv.removeClass('is-invalid');
    }

    if (!$dateError.hasClass('d-none')) {
        $datePickerWrapper.addClass('is-invalid');
    } else {
        $datePickerWrapper.removeClass('is-invalid');
    }

    if (!isValid) return;
    $.spinner().start();
    $.ajax({
        url: astrologerDetailsUrl,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            offSelectedStore: offSelectedStore,
            offSelectedSlot: offSelectedSlot,
            offlineselectedDate: offlineselectedDate,
            onlineselectedslot: onlineselectedslot,
            onlineselecteddate: onlineselecteddate
        },
        success: function (data) {
            $('#astral-detailspage-container').html(data);
            $('#astral-detailspage-container').removeClass('d-none');
            $('#astral-selectedpage-container').addClass('d-none');
            $('html, body').animate({
                scrollTop: $('.appointment-service').offset().top
            }, 500);
            $('.appointment-service').scrollTop(0);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '#astrologerdetailsbtn, #astrologerstore-btn', function (e) {
    e.preventDefault();

    var formDetailsUrl = $(this).data('url');
    var isDetailsBtn = $(this).attr('id') === 'astrologerdetailsbtn';
    var isStoreBtn = $(this).attr('id') === 'astrologerstore-btn';
    var selectedoption = $('#selectedoption').val();
    var staffid = $('#offlinebackselectedstaffid').val() || '';
    // var selectedAstrologer = $('#astral-detailspage-container').data('selected-staff-id')
    //     || $('#astrostaffid').val()
    //     || $('#astral-detailspage-container .astrologer-details .astro-card.checked').data('id')
    //     || '';
    var isValid = true;
    var dateSelected = $('#ckc-astral-appointment-date').val().trim();
    var slotSelected = $('#astralstorepage-container .astral-selected-value').text().trim();

    if (dateSelected === '') {
        $('.select-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (slotSelected === 'select your slot') {
        $('.pickup-slots').removeClass('d-none');
        isValid = false;
    }

    if (!isValid) return;
    $.spinner().start();
    $.ajax({
        url: formDetailsUrl,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            staffid: staffid
        },
        success: function (data) {
            if (isDetailsBtn) {
                $('#astral-form-details').removeClass('d-none').html(data);
                $('#astral-detailspage-container').addClass('d-none');
            }

            if (isStoreBtn) {
                $('#astral-form-details').removeClass('d-none').html(data);
                $('#astralstorepage-container').addClass('d-none');
            }

            // Coming into the form details page from previous steps should start
            // with a clean upload state (no carry-over from prior navigation).
            resetUploadedFiles();

            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#astral-form-details').offset().top
            }, 500);
            $('#astral-form-details').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '.goback-astrologer', function (e) {
    e.preventDefault();
    $('#astral-form-details').addClass('d-none');
    var storepageUrl = $('#storepageUrl').val();
    var selectedoption = $('#selectedoption').val();
    var astrostaffid = $('#astrostaffid').val();
    var astralbackselectedStore = $('#astralstorepage-container .storedata .store-container.checked input[type="radio"]').val() || '';
    var astralbackselectedDate = $('#ckc-astral-appointment-date').val() || '';
    var astralbackselectedSlot = $('#astralstorepage-container .astral-selected-value').text().trim() || '';
    $.spinner().start();
    $.ajax({
        url: storepageUrl,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            staffid: astrostaffid,
            selectedStore: astralbackselectedStore,
            selectedDate: astralbackselectedDate,
            selectedSlot: astralbackselectedSlot
        },
        success: function (data) {
            $('#astralstorepage-container').removeClass('d-none');
            $('#astralstorepage-container').html(data);
            var responseSelectedDate = $('#astralbackselectedDate').val();
            // var responseSelectedSlot = $('#astralbackselectedSlot').val();
            if (responseSelectedDate) {
                $('#ckc-astral-appointment-date').val(responseSelectedDate);
            }
            $('#astralstorepage-container .custom-drop-down .astral-selected-value').addClass('timeslot-selected-value');
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#astral-form-details').offset().top
            }, 500);
            $('#astral-form-details').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '.go-to-previouspage', function (e) {
    e.preventDefault();
    $('#astral-form-details').addClass('d-none');
    var detailspageUrl = $('#astrologerdetails-page').val();
    var selectedoption = $('#selectedoption').val();
    var selectedAstrologer = $('#astral-detailspage-container').data('selected-staff-id')
        || $('#astrostaffid').val()
        || $('#astral-detailspage-container .astrologer-details .astro-card.checked').data('id')
        || '';
    var selectedStore = $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val() || '';
    var selectedDate = $('#ckc-astral-appointment-date').val() || '';
    var selectedSlot = $('#astral-selectedpage-container .astral-selected-value').text().trim() || '';
    $.spinner().start();
    $.ajax({
        url: detailspageUrl,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            selectedAstrologer: selectedAstrologer,
            backselectedStore: selectedStore,
            backselectedDate: selectedDate,
            backselectedSlot: selectedSlot
        },
        success: function (data) {
            $('#astral-detailspage-container').removeClass('d-none');
            $('#astral-detailspage-container').html(data);
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#astral-detailspage-container').offset().top
            }, 500);
            $('#astral-detailspage-container').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '#astralformdetailsbtn', function (e) {
    e.preventDefault();

    var isValid = true;
    var $firstInvalidField = null;
    var $form = $('#astral-formdata-details');
    var selectedoption = $('#selectedoption').val();
    $('#astral-formdata-details input').each(function () {
        var $field = $(this);
        if (!$field.prop('required') && !$field.closest('.form-group').hasClass('required')) {
            return;
        }
        if (!validateField($field)) {
            isValid = false;
            if (!$firstInvalidField) {
                $firstInvalidField = $field;
            }
        }
    });

    if (selectedoption === 'online') {
        var $uploadFileBase64 = $('#uploadFileBase64');
        var $uploadFileUrl = $('#uploadFileUrl');
        var $fileError = $('.pan-file-error');
        var $missingFileError = $fileError.data('missing-error');

        if (!$uploadFileBase64.val() && !$uploadFileUrl.val()) {
            isValid = false;
            $fileError.text($missingFileError);
            if (!$firstInvalidField) {
                $firstInvalidField = $('.upload-file-upload');
            }
        } else {
            $fileError.text('');
        }
    }

    if (!isValid) {
        if ($firstInvalidField && $firstInvalidField.length) {
            var $target = $firstInvalidField;
            var $wrapper = $target.closest('.form-group');
            var $scrollTarget = $wrapper.length ? $wrapper : $target;
            $('html, body').animate({
                scrollTop: $scrollTarget.offset().top - 200
            }, 400, function () {
                focusField($target);
            });
        }
        return;
    }
    // var selectedStore = $('#astral-detailspage-container .storedata .store-container.checked input[type="radio"]').val();
    var submitUrl = $form.find('input[name="savedastralformdata"]').val();
    var slectedShowroomID = $form.find('#backselectedStore').val()
        || $('#astralstorepage-container').data('selected-showroom-id')
        || $('#astral-selectedpage-container .astrologer-details .astro-card.checked').data('show-id')
        || $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val()
        || $('#astralstorepage-container .storedata .store-container.checked input[type="radio"]').val()
        || '';
    var selectedLabel = $('label[for="storedata-' + slectedShowroomID + '"]');

    // Check if we have base64 data (backward compatibility)
    var uploadFileBase64 = $form.find('#uploadFileBase64').val().trim();
    var uploadFileUrl = $form.find('#uploadFileUrl').val().trim();

    // Use URL if available (new multipart upload), otherwise use base64 (legacy)
    var uploadFileValue = uploadFileUrl || uploadFileBase64;

    var formData = {
        firstName: $form.find('#firstName').val().trim(),
        lastName: $form.find('#lastName').val().trim(),
        email: $form.find('#email').val().trim(),
        phone: $form.find('#phone').val().trim(),
        dateofbirth: $form.find('#dateofbirth').val().trim(),
        timeofbirth: $form.find('#timeofbirth').val().trim(),
        placeofbirth: $form.find('#placeofbirth').val().trim(),
        uploadFileBase64: uploadFileValue,
        optionattribute: $form.find('#optionattribute').val().trim(),
        selectedoption: selectedoption,
        termsAccepted: $form.find('#termsAccepted').is(':checked'),
        slectedShowroomID: slectedShowroomID,
        slectedStaffid: $form.find('#staffid').val()
            || $('#astralstorepage-container').data('selected-staff-id')
            || $('#astrostaffid').val()
            || $('#astral-detailspage-container .astrologer-details .astro-card.checked').data('id')
            || '',
        selectedStaffName: $form.find('#staffname').val()
            || $('#astralstorepage-container').data('selected-staff-name')
            || $('#astral-detailspage-container .astrologer-details .astro-card.checked').data('name')
            || $('.astrologer-details .astro-card.checked').attr('data-name') || '',
        storeName: selectedLabel.find('.store-name').text().trim(),
        storeAddress: selectedLabel.find('.store-address').text().trim(),
        selectedDate: $form.find('#ckc-astral-appointment-date').val()
            || $('#astralstorepage-container #ckc-astral-appointment-date').val()
            || $('#astral-selectedpage-container #ckc-astral-appointment-date').val()
            || $('#astral-detailspage-container #ckc-astral-appointment-date').val()
            || '',
        selectedSlot: $form.find('#astraltimeslot .astral-selected-value').text().trim()
            || $('#astralstorepage-container .astral-selected-value').text().trim()
            || $('#astral-selectedpage-container .astral-selected-value').text().trim()
            || '',
        countryCode: $form.find('.country-code-text').text() || '',
        Salutation: $form.find('#catalogueTitle').val() || ''
    };
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response) {
                $('#astral-form-details').addClass('d-none');
                $('#astral-customer-details-container').removeClass('d-none');
                $.ajax({
                    url: response.redirectUrl,
                    method: 'GET',
                    data: {
                        appointmentID: response.appointmentID
                    },
                    success: function (responseHtml) {
                        var $astralcustomerDetails = $('#astral-customer-details-container');
                        $astralcustomerDetails.html(responseHtml);
                        $.spinner().stop();
                        $('html, body').animate({
                            scrollTop: $astralcustomerDetails.offset().top
                        }, 500);
                    },
                    error: function (error) {
                        toastMessageHelper.showNotification(errorMessage, error);
                    }
                });
            }
        },
        error: function (error) {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage, error);
        }
    });
});

/**
 * Calculates total price including base price and dynamic astral prices.
 * @param {number|string} basePrice - Base product price
 * @returns {number} total calculated price
 */
function calculateTotal(basePrice) {
    var $priceElements = $('#dynamic-price-items .astral-price');
    var total = Number(basePrice) || 0;

    $priceElements.each(function () {
        var getPriceText = $(this).text();
        var priceText = getPriceText.replace(/[^0-9.]/g, '').trim();
        var price = Number(priceText);
        if (!isNaN(price)) { // eslint-disable-line
            total += price;
        }
    });
    return total;
}

/**
 * Updates the total price summary for selected Area of Interests.
 *
 * This function calculates the total amount based on:
 * - A provided base price (if passed), OR
 *
 * @function updatePriceTotals
 * @param {number} [basePrice] - Optional base price value.
 * If provided, it overrides individual item prices.
 *
 * @returns {void}
 */
function updatePriceTotals(basePrice) {
    var total = 0;

    if (basePrice) {
        total = calculateTotal(basePrice);
    } else {
        total = calculateTotal(0);
    }
    // Calculate GST (assuming 18%)
    // var gst = total * 0.18;
    // var amountPayable = total + gst;
    var formData = {
        totalAmount: total.toFixed(2)
    };
    var submitUrl = $('.dynamic-price-items').data('url').toString();
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response.success) {
                var netAmount = response.netAmount;
                var gstAmount = response.gstAmount;
                var payableAmount = response.grossAmount;
                // Update the display
                $('.price-summary-sections').find('#netAmount').eq(0).text(netAmount);
                $('.price-summary-sections.separator').find('#gstAmount').text(gstAmount);
                $('.price-summary-sections').last().find('#payableAmount').text(payableAmount);
                $.spinner().stop();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

$('body').on('change', '.area-option', function () {
    var value = $(this).val();
    var checkboxId = $(this).attr('id');
    var serviceValue = value || '0.00';
    var basePrice = $('#basePrice').val();
    var areaOfInterest = $('#filteredAreaOfInterests').val() ? JSON.parse($('#filteredAreaOfInterests').val()) : [];
    var filteredBasePrice = $('#filteredBasePrice').val() ? JSON.parse($('#filteredBasePrice').val()) : '';
    if (areaOfInterest && areaOfInterest.length > 0) {
        areaOfInterest.forEach(function (item) {
            serviceValue = (item.name === checkboxId) ? Number(item.amount) : serviceValue;
            basePrice = filteredBasePrice ? Number(filteredBasePrice) : basePrice;
        });
    }

    var currencySymbol = $('#currencySymbol').val() || '₹';

    if ($(this).is(':checked')) {
        $('#selectedTags').append(
            '<span class="selected-tag" data-val="' + checkboxId + '">' + checkboxId + '</span>'
        );
        $('#dynamic-price-items').append(
            '<div class="price-summary-section d-flex flex-row justify-content-between w-100" data-service-item="' + checkboxId + '">'
                + '<span class="astralprice-charges col-8 p-0">Areas of Importance - ' + checkboxId + ' Charges</span>'
                + '<span class="astralprice-charges astral-price col-4 text-right p-0">' + currencySymbol + serviceValue + '</span>'
            + '</div>'
        );
        if (basePrice && basePrice !== null && basePrice !== '' && typeof basePrice !== 'undefined') {
            $('#dynamic-base-price').html(
                '<div class="price-summary-section d-flex flex-row justify-content-between w-100">'
                    + '<span class="col-8 p-0 price-charges">Package Charges</span>'
                    + '<span class="col-4 price basepricetotal text-right p-0">' + currencySymbol + basePrice + '</span>'
                + '</div>'
            );
        }

        updatePriceTotals(Number(basePrice));
    } else {
        if (basePrice && basePrice !== null && basePrice !== '' && typeof basePrice !== 'undefined') {
            $('#dynamic-base-price').html(
                '<div class="price-summary-section d-flex flex-row justify-content-between w-100">'
                    + '<span class="col-8 p-0 price-charges">Package Charges</span>'
                    + '<span class="col-4 price basepricetotal text-right p-0">' + currencySymbol + basePrice + '</span>'
                + '</div>'
            );
        }
        $('#selectedTags').find('[data-val="' + checkboxId + '"]').remove();
        // Remove price row from dynamic price section
        $('#dynamic-price-items').find('[data-service-item="' + checkboxId + '"]').remove();

        updatePriceTotals(Number(basePrice));
    }

    if ($('#selectedTags .selected-tag').length > 0) {
        $('.astralService-error').addClass('d-none');
    } else {
        localStorage.setItem('basePrice', false);
        updatePriceTotals(0);
        $('#dynamic-base-price').empty();
    }
});

$('body').on('click', '.goback-onlinepage, .goback-offlinepage', function (e) {
    e.preventDefault();
    var astralonlinepage = $(this).data('url');
    var selectedoption = $('#selectedoption').val();
    var backselectedStore = $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val() || '';
    var backselectedDate = $('#ckc-astral-appointment-date').val() || '';
    var backselectedSlot = $('#astral-selectedpage-container .astral-selected-value').text().trim() || '';
    $.spinner().start();
    $.ajax({
        url: astralonlinepage,
        type: 'GET',
        data: {
            selectedoption: selectedoption,
            backselectedSlot: backselectedSlot,
            backselectedDate: backselectedDate,
            backselectedStore: backselectedStore
        },
        success: function (data) {
            $('#astral-selectedpage-container').html(data);
            $('#astral-selectedpage-container').removeClass('d-none');
            $('#astral-detailspage-container').addClass('d-none');

            var responseSelectedDate = $('#backselectedDate').val();
            if (responseSelectedDate) {
                $('#ckc-astral-appointment-date').val(responseSelectedDate);
            }
            $('.bottom-content #slot-dropdown-section').removeClass('slot-dropdown-section');
            $('.bottom-content .custom-drop-down.slot-dropdown').removeClass('disabledstate');
            $('#astral-selectedpage-container .custom-drop-down .astral-selected-value').addClass('timeslot-selected-value');
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#astral-selectedpage-container').offset().top
            }, 500);
            $('#astral-selectedpage-container').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '.astral-datasave-btn', function (e) {
    e.preventDefault();
    var selectedTags = [];
    var $astralAreaOfInterest = $('.store-pickup-details');
    $('#selectedTags .selected-tag').each(function () {
        selectedTags.push($(this).data('val'));
    });
    var isValid = true;
    var appointmentID = $('#appointmentID').val();
    var whatsappOption = $astralAreaOfInterest.find('#whatsappoption').is(':checked');
    var textmessage = $astralAreaOfInterest.find('#textoption').is(':checked');
    var emailOption = $astralAreaOfInterest.find('label[for="emailoption"]').hasClass('checked');
    var netAmount = $('#netAmount').text().replace(/[^0-9.]/g, '').trim();
    var grossAmount = $('#payableAmount').text().replace(/[^0-9.]/g, '').trim();
    var gstAmount = $('#gstAmount').text().replace(/[^0-9.]/g, '').trim();

    if (selectedTags.length === 0) {
        var $error = $('.astralService-error');
        $error.removeClass('d-none');
        $('html, body').animate({
            scrollTop: $error.offset().top - 300
        }, 300);
        isValid = false;
    }

    if (!isValid) {
        return;
    }
    $.spinner().start();
    var saveUrl = $(this).data('save-url');
    $.ajax({
        url: saveUrl,
        type: 'POST',
        data: {
            selectedTags: selectedTags.join(','),
            appointmentID: appointmentID,
            whatsappOption: whatsappOption,
            textmessage: textmessage,
            emailOption: emailOption,
            netAmount: netAmount,
            grossAmount: grossAmount,
            gstAmount: gstAmount
        },
        success: function (response) {
            if (response.success) {
                $.spinner().stop();
                $('body').trigger('checkout:razorpaycheckout');
            } else {
                $.spinner().stop();
                toastMessageHelper.showNotification(response.message || errorMessage, 'error');
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('change input blur', '#astral-formdata-details input', function () {
    validateField($(this));
    if ($(this).hasClass('firstname-input')) {
        var $customDropdown = $('.firstname-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $customDropdown.addClass('error-valid');
        } else {
            $customDropdown.removeClass('error-valid');
        }
    }
    if ($(this).hasClass('phone-input')) {
        var $phoneDropdown = $('.phone-input-field').find('.country-code-text');
        if ($(this).hasClass('is-invalid')) {
            $phoneDropdown.addClass('error-valid');
        } else {
            $phoneDropdown.removeClass('error-valid');
        }
    }
});

$('body').on('click', '#astralstorepage-container .time-slot-session .time-slot-value, #astral-selectedpage-container .time-slot-session .time-slot-value', function () {
    var $this = $(this);
    var $selected = $this.closest('.time-slot-select').find('.custom-drop-down-section .selected-value');
    $selected.addClass('timeslot-selected-value');
    $('.time-slot-select .slot-dropdown-section').removeClass('is-invalid');
});

$('body').on('click', '#astralstorepage-container .storedata .store-container, #astral-selectedpage-container .storedata .store-container', function () {
    $('#astralstorepage-container .storedata .store-container, #astral-selectedpage-container .storedata .store-container').removeClass('checked');
    $(this).addClass('checked');
    var $dateInput = $('#ckc-astral-appointment-date');
    $dateInput.datepicker('setDate', null);
    $dateInput.val('');
    $('#astraltimeslot .session-time-slots li').removeClass('active');
    $('.astral-selected-value').each(function () {
        var altText = $(this).data('alttext');
        $(this).text(altText || '').removeClass('timeslot-selected-value');
    });
});

$('body').on('click', '.form-firstname-dropdown .custom-option-value', function () {
    var $this = $(this);
    var titleCode = $this.data('title');
    var titleText = $this.text().trim();
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    $this.closest('.custom-drop-down-section').find('.selected-value').text(titleText);
    $('#catalogueTitle').val(titleCode);
});

/**
 * Fetches and renders the Astral appointment service content.
 *
 * This function checks for the presence of the `.appointment-service`
 * element in the DOM. If available, it reads the `data-url` attribute
 * and makes an AJAX GET request to fetch appointment-related content.
 *
 * - If the response indicates `success === false`, the user is redirected
 *   to the provided `redirectUrl`.
 * - Otherwise, the returned HTML is injected into the
 *   `.appointment-service` container.
 *
 * In case of an AJAX error, a toast notification is displayed.
 *
 * @function astralAppointments
 * @returns {void}
 */
function astralAppointments() {
    var url = new URL(window.location.href);
    var paramValue = url.searchParams.get('name');
    url.searchParams.delete('name');
    window.history.replaceState({}, document.title, url.toString());

    var $appointmentService = $('.appointment-service');
    if (!$appointmentService.length) {
        return;
    }
    var Appointmentservice = $appointmentService.attr('data-url');

    $.ajax({
        url: Appointmentservice,
        type: 'GET',
        data: {
            name: paramValue
        },
        success: function (data) {
            if (data.success === false && !(data.login)) {
                $('#ckc-login-modal').modal('show');
                $('#ckc-login-modal').on('hidden.bs.modal', function () {
                    window.location.href = data.redirectUrl;
                });
            } else {
                $appointmentService.html(data);
            }
        },
        error: function () {
            toastMessageHelper.showNotification(errorMessage);
        }
    });
}

$(document).ready(function () {
    if ($('.appointment-service').length) {
        astralAppointments();
    }
});

$(document).on('click', '.hero-button', function () {
    if ($('.appointment-service').length === 0) {
        return;
    }

    var parentSection = $(this).closest('.pd-hero-banner');
    var sectionHeight = parentSection.outerHeight(true);
    var currentScroll = $(window).scrollTop();
    // var headerHeight = $('.header').outerHeight() || 0;

    $('html, body').animate({
        scrollTop: currentScroll + sectionHeight
    }, 600);
});

$('body').on('change', '#ckc-pickup-appointment-date, #ckc-astral-appointment-date', function () {
    $('.select-date-picker').addClass('d-none');
    $('.date-picker-input').removeClass('is-invalid');
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var $tasSelectedValue = $('.astral-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.removeClass('timeslot-selected-value');
        $('.session-time-slots .time-slot-value').removeClass('time-slot-value-highlight');
    }
});

$(document).on('click', '.astralcancelbook-btn', function (e) {
    e.preventDefault();
    var cancelUrl = $('#cancelBookingUrl').val();
    var appointmentID = $('#appointmentID').val();

    if (!cancelUrl) {
        window.location.reload();
        return;
    }

    $.spinner().start();
    $.ajax({
        url: cancelUrl,
        method: 'POST',
        data: {
            appointmentID: appointmentID
        },
        success: function (response) {
            if (response && response.success) {
                window.location.reload();
                $.spinner().stop();
            } else {
                toastMessageHelper.showNotification(errorMessage);
                $.spinner().stop();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$('body').on('click', '#astraledit-btn', function (e) {
    e.preventDefault();
    $.spinner().start();
    $('#astral-customer-details-container').addClass('d-none');
    $('#astral-form-details').removeClass('d-none');
    $('.pan-file-error').text('');
    $('html, body').animate({
        scrollTop: $('#astral-form-details').offset().top
    }, 500);
    $('#astral-form-details').scrollTop(0);
    $.spinner().stop();
});

$('body').on('change input blur', '#ckc-astral-appointment-date', function () {
    $('.invalid-feedback .noslots-available').addClass('d-none');
    var selectedDate = $(this).val();
    var $slotdropdown = $('#slot-dropdown-section .slot-dropdown');
    var $slotdiv = $('.time-slot-select .custom-drop-down-section');

    if (selectedDate) {
        $slotdropdown.removeClass('disabledstate');
        $slotdiv.removeClass('slot-dropdown-section');
    } else {
        $slotdropdown.addClass('disabledstate');
        $slotdiv.addClass('slot-dropdown-section');
    }
});

$(document).on('click focus', '#timeofbirth', function () {
    var timePicker = initTimeOfBirthPicker();

    if (!timePicker) {
        return;
    }

    timePicker.open();

    if (timePicker.altInput) {
        timePicker.altInput.focus();
    }
});

$('body').on('click', '#astralonlinetimeslot', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }
    var selectedDate = $('#ckc-astral-appointment-date').val().trim();
    if (!selectedDate) {
        return;
    }
    var selectedslot = $('.astral-selected-value').attr('data-slot');
    var url = $(this).data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#astralonlinetimeslotplaced').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.pickup-slots, .pickup-slot-scroll.scroll-bar').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('.pickup-slot-scroll.scroll-bar').removeClass('d-none');
            $('#astralonlinetimeslotplaced').html(data);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#astralonlinetimeslot .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;
    var selectedSlot = $(this).data('id');
    $('#astralonlinetimeslotplaced').val(selectedSlot);
    $('.astral-selected-value').attr('data-slot', selectedSlot);
});

$(document).ready(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var errorParam = urlParams.get('error');

    if (errorParam) {
        var decodedError = decodeURIComponent(errorParam);
        toastMessageHelper.showNotification(decodedError);
        var url = new URL(window.location);
        url.searchParams.delete('error');
        window.history.replaceState({}, '', url);
    }
});
